import { Link } from "react-router-dom";
import { DateTime } from "luxon";

//Assets
import { ReactComponent as CicleLink } from "../../assets/img/circle-link.svg";

const ProjectItem = ({ id, featured, styleClass, title, slug, image, completed, location, animationDelay }) => {
	return (
		<Link to={`/projects/project/${slug}`} className={`projectItem project-reveal ${styleClass}`} style={{ animationDelay: `${animationDelay}ms` }} data-featured={featured}>
			<img src={`${image}?w=500`} alt={`Thumbnail for ${title}`} />
			<div className="flex jContent-spaceBetween aItems-end padding-small projectItem-titleWrapper">
				<div className="title">
					<div className="subTitle fontSize-small fontColour-lighter flex gap-small">
						<span>{location}</span>
						{/* {completed && (
							<>
								<span>//</span>
								<span>{DateTime.fromISO(completed).toFormat("MMM yyyy")}</span>
							</>
						)} */}
					</div>
					<span className="limitLines-1">{title}</span>
				</div>
				<div className="projectItem-link aSelf-center fontSize-medium">
					<i className="bi bi-arrow-right-short"></i>
				</div>
				{/* <CicleLink /> */}
			</div>
		</Link>
	);
};

export default ProjectItem;
